var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47933 28.34C0.662521 25.2917 2.47156 22.1583 5.51994 21.3415L60.7157 6.55184C63.7641 5.73503 66.8974 7.54407 67.7142 10.5925L75.1091 38.1903C75.9259 41.2387 74.1168 44.3721 71.0685 45.1889L15.8727 59.9785C12.8243 60.7953 9.69097 58.9863 8.87416 55.9379L1.47933 28.34Z",
    fill: "#CDAFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5625C0 25.5049 2.55837 22.2156 5.71429 22.2156C28.5714 22.2156 51.4286 22.2156 74.2857 22.2156C77.4416 22.2156 80 25.5049 80 29.5625V66.2972C80 70.3548 77.4416 73.6441 74.2857 73.6441H5.71429C2.55838 73.6441 0 70.3548 0 66.2972V29.5625Z",
    fill: "#B98EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4277 34.3586C11.4277 33.9641 11.7475 33.6443 12.142 33.6443H27.8563C28.2508 33.6443 28.5706 33.9641 28.5706 34.3586V36.5014C28.5706 36.8959 28.2508 37.2157 27.8563 37.2157H12.142C11.7475 37.2157 11.4277 36.8959 11.4277 36.5014V34.3586ZM11.4277 42.2157C11.4277 41.8212 11.7475 41.5014 12.142 41.5014H22.142C22.5365 41.5014 22.8563 41.8212 22.8563 42.2157V44.3586C22.8563 44.7531 22.5365 45.0729 22.142 45.0729H12.142C11.7475 45.0729 11.4277 44.7531 11.4277 44.3586V42.2157ZM65.7134 47.93C65.7134 50.2969 63.7947 52.2157 61.4277 52.2157C59.0608 52.2157 57.142 50.2969 57.142 47.93C57.142 45.5631 59.0608 43.6443 61.4277 43.6443C63.7947 43.6443 65.7134 45.5631 65.7134 47.93ZM68.5706 47.93C68.5706 51.8749 65.3726 55.0729 61.4277 55.0729C57.4828 55.0729 54.2849 51.8749 54.2849 47.93C54.2849 43.9851 57.4828 40.7871 61.4277 40.7871C65.3726 40.7871 68.5706 43.9851 68.5706 47.93Z",
    fill: "#F3ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCard);
export default __webpack_public_path__ + "static/media/walletCard.bf7c373ac2d9f1f60b7d289d932854dc.svg";
export { ForwardRef as ReactComponent };